<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p *ngIf="data.body">{{data.body}}</p>
  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>{{data.label}}</mat-label>
    <input matInput
           [placeholder]="data.placeholder || ''"
           [(ngModel)]="value"
           cdkFocusInitial
           (keydown.enter)="onOk()"/>
  </mat-form-field>
</div>
<!--
  Emphasis belongs on the button that carries out what was asked for.
  Cancel used to be `mat-flat-button color="accent"` -- a solid, filled
  button sitting next to the solid, filled OK, so the two competed and
  the destructive-free escape hatch was the louder of the pair. Stroked
  matches the Confirm dialog next door and the `.Discard-btn` the
  legacy dialogs use, which is the point: one dismiss treatment app-wide.
-->
<div mat-dialog-actions>
  <button mat-stroked-button (click)="onCancel()">{{data.cancelButton}}</button>
  <button mat-flat-button color="primary" (click)="onOk()">{{data.okButton}}</button>
</div>

